import { render, staticRenderFns } from "./TableViewDeleted.vue?vue&type=template&id=5106a408"
import script from "./TableViewDeleted.vue?vue&type=script&lang=js"
export * from "./TableViewDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports